// extracted by mini-css-extract-plugin
module.exports = {"itemIndicator":"styles_itemIndicator__i5TgE"};